module.exports = __webpack_public_path__ + "img/beetle_body.9e4aff15.png";